import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body, HeadingSmall} from "@khanacademy/wonder-blocks-typography";
import {mediaQueries} from "@repo/shared-styles";
import {staticUrl} from "@repo/urls";

type Props = {
    title: string;
    description: string;
    imgUrl: string;
    imgAltText: string;
    imgPlacement: "left" | "right";
};

export default class ImageLadderRung extends React.Component<Props> {
    render(): React.ReactNode {
        const {imgPlacement, imgUrl, imgAltText, title, description} =
            this.props;

        const positionStyle =
            imgPlacement === "left" ? styles.left : styles.right;

        return (
            <View style={[positionStyle, styles.container]}>
                <View style={styles.imageContainer}>
                    <img
                        className={css(styles.image)}
                        src={staticUrl(imgUrl)}
                        alt={imgAltText}
                    />
                </View>
                <Strut size={spacing.small_12} />
                <View style={styles.textContainer}>
                    <HeadingSmall tag="h2" style={styles.heading}>
                        {title}
                    </HeadingSmall>
                    <Body style={styles.body}>{description}</Body>
                </View>
                <Strut size={spacing.xxLarge_48} />
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        alignItems: "flex-start",
        justifyContent: "center",

        [mediaQueries.smOrSmaller]: {
            marginLeft: 20,
            marginRight: 20,
        },
    },

    left: {
        flexDirection: "row",

        [mediaQueries.smOrSmaller]: {
            flexDirection: "column",
            alignItems: "center",
        },
    },

    right: {
        flexDirection: "row-reverse",
        justifyContent: "flex-end",

        [mediaQueries.smOrSmaller]: {
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
        },
    },

    imageContainer: {
        margin: 15,
        maxWidth: 500,

        [mediaQueries.smOrSmaller]: {
            marginTop: 0,
            textAlign: "center",
        },
    },

    image: {
        width: "100%",
        margin: "auto",
        display: "block",
    },

    textContainer: {
        marginTop: 40,
        marginBottom: 20,
        maxWidth: 430,

        [mediaQueries.smOrSmaller]: {
            marginTop: 0,
            textAlign: "center",
        },
    },

    heading: {
        fontSize: 21,
        lineHeight: 1.52,
        fontWeight: "bold",

        [mediaQueries.smOrSmaller]: {
            fontSize: 19,
            lineHeight: 1.68,
        },
    },

    body: {
        color: color.offBlack64,
        fontSize: 18,
        lineHeight: 1.33,

        [mediaQueries.mdOrSmaller]: {
            fontSize: 15,
            lineHeight: 1.53,
        },
    },
});
